import React, { useState, useEffect } from 'react';
import { Modal, Form, DatePicker, Switch } from 'antd';
import dayjs from 'dayjs';

export default function HarvestModal({ open, crop, onClose, onSave }) {
  const [form] = Form.useForm();
  const [harvestDate, setHarvestDate] = useState(null);
  const [saving, setSaving] = useState(false);
  const sowingDate = crop?.crop_date ? dayjs(crop.crop_date) : null;

  useEffect(() => {
    if (open) {
      const hd = crop?.harvest_date ? dayjs(crop.harvest_date) : null;
      setHarvestDate(hd);
      form.setFieldsValue({ harvest_date: hd, status: false });
    }
  }, [open, crop, form]);

  const handleSave = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      const values = form.getFieldsValue();
      const payload = {
        cropId: crop.id,
        cropName: crop.crop_name || crop.crop,
        verity: crop.verity || '',
        area: crop.area,
        areaUnit: String(crop.area_unit || '3'),
        farm: crop.farm_id,
        date: crop.crop_date || '',
        plotId: crop.plot_id || null,
        hasPlot: false,
        plotName: '',
        plotPath: null,
        sqmArea: '',
        common_id: crop.common_id || null,
        harvest_date: values.harvest_date ? values.harvest_date.format('YYYY-MM-DD') : '',
        status: values.status ? 0 : 1,
      };
      await onSave(payload);
    } catch {} finally { setSaving(false); }
  };

  return (
    <Modal
      title="Mark as Harvested"
      open={open}
      onCancel={onClose}
      onOk={handleSave}
      okText="Save"
      okButtonProps={{ loading: saving, style: { background: '#d46b08', borderColor: '#d46b08' } }}
      destroyOnClose
    >
      <Form form={form} layout="vertical" size="large">
        <Form.Item
          label="Harvest Date"
          name="harvest_date"
          rules={[
            { required: true, message: 'Select harvest date' },
            {
              validator: (_, value) => {
                if (value && sowingDate && !value.isAfter(sowingDate, 'day'))
                  return Promise.reject('Harvest date must be after sowing date');
                return Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker
            style={{ width: '100%' }}
            disabledDate={(d) => sowingDate && d && !d.isAfter(sowingDate, 'day')}
            onChange={(d) => {
              setHarvestDate(d);
              if (!d) form.setFieldsValue({ status: false });
            }}
          />
        </Form.Item>
        <Form.Item>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', background: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
            <div>
              <div style={{ fontWeight: 500, fontSize: 14 }}>Mark as Harvested</div>
              {!harvestDate && <div style={{ fontSize: 12, color: '#faad14', marginTop: 2 }}>Please select harvest date to enable</div>}
            </div>
            <Form.Item name="status" valuePropName="checked" noStyle>
              <Switch disabled={!harvestDate} checkedChildren="Harvested" unCheckedChildren="Active" className="harvest-switch" />
            </Form.Item>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}
